export const foldAccents = (text) => String(text || '').normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

/** "1 post", "3 posts", "0 post": French plural, zero stays singular. */
export const plural = (n, word, many = `${word}s`) => `${n} ${n > 1 ? many : word}`;
